import { useState } from 'react';

export const useModal = (defaultValue) => {
  const [isOpen, setIsOpen] = useState(defaultValue);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const toggleModal = () => setIsOpen(prev => !prev);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  };
};
